'use strict';
const angular = require('angular');

/*@ngInject*/
export function ProjectItemService($resource) {
  return $resource('/api/project-items/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    }
  });
}


export default angular.module('conduu.ProjectItemService', [])
  .factory('ProjectItemService', ProjectItemService)
  .name;



// WEBPACK FOOTER //
// ./client/components/project-item/project-item.service.js